import { ApiEndpoint } from "/shortcodes";
import * as React from 'react';
export default {
  ApiEndpoint,
  React
};